import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import React from 'react'

import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { TestimonialRecordFieldsFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import { useResponsiveLayout } from 'Hooks'

import Button from './Button'
import TestimonialCard from './Card'
import { Container, Mask } from './styles'

type Props = {
  data?: TestimonialRecordFieldsFragment[]
}

function TestimonialGallery({ data }: Props) {
  const { isMobile, isDesktop } = useResponsiveLayout()

  if (!data) return null

  return (
    <Container>
      <Swiper
        centeredSlides
        grabCursor
        loop
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={isDesktop ? 3 : 1}
      >
        {!isMobile && (
          <>
            <Mask />
            <Button />
            <Button isNext />
          </>
        )}

        {data.map(item => (
          <SwiperSlide key={item.id}>
            <TestimonialCard data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  )
}

export default TestimonialGallery
